export default __webpack_public_path__ + "static/media/stacey.2c48939d.png";